// extracted by mini-css-extract-plugin
export default {"textMessageList":"TextMessageList_textMessageList__OaIDD","textMessage":"TextMessageList_textMessage__AOiao"};